// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      opsNotificationType: [
        "C1",
        "C2",
        "D1",
        "D2",
        "D3",
        "M1",
        "M2",
        "S1",
        "S2",
        "S3",
        "S4",
        "T1",
        "T2",
        "UD"
      ],
      opsNotificationOrigin: [
        "Routine",
        "Project",
        "Inspection",
        "Maint",
        "Event"
      ]
    };
  }
};
